import { render, staticRenderFns } from "./scrollview.vue?vue&type=template&id=d43c5b94&"
import script from "./scrollview.vue?vue&type=script&lang=js&"
export * from "./scrollview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/scrollview.vue
// module id = null
// module chunks = 